import React from "react";
import InsertDesigns from "../../data/insertDesigns.json";

// ── Style tokens ────────────────────────────────────────────────────────────
const lbl = {
    display: "block",
    marginBottom: "0.3rem",
    fontSize: "0.78rem",
    fontWeight: 700,
    letterSpacing: "0.05em",
    textTransform: "uppercase",
    color: "#64748b",
};
const inputBase = {
    width: "100%",
    padding: "0.5rem 0.65rem",
    fontSize: "0.93rem",
    color: "#1e293b",
    background: "#f8fafc",
    border: "1px solid #e2e8f0",
    borderRadius: "8px",
    outline: "none",
    transition: "border-color 0.15s ease, box-shadow 0.15s ease",
};
const focusHandlers = {
    onFocus: (e) => {
        e.target.style.borderColor = "#2c7aa0";
        e.target.style.boxShadow = "0 0 0 3px rgba(44,122,160,0.12)";
        e.target.style.background = "#ffffff";
    },
    onBlur: (e) => {
        e.target.style.borderColor = "#e2e8f0";
        e.target.style.boxShadow = "none";
        e.target.style.background = "#f8fafc";
    },
};
const fw = { marginBottom: "0.65rem" };
const g2 = {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "0.65rem",
    marginBottom: "0.65rem",
};
const subHeader = {
    fontSize: "0.72rem",
    fontWeight: 700,
    letterSpacing: "0.06em",
    textTransform: "uppercase",
    color: "#94a3b8",
    margin: "0.75rem 0 0.4rem",
    display: "block",
};

// ── Field wrapper ────────────────────────────────────────────────────────────
const F = ({ label, children, err }) => (
    <div style={fw}>
        <label style={lbl}>{label}</label>
        {children}
        {err && (
            <p style={{ margin: "0.2rem 0 0", fontSize: "0.75rem", color: "#dc2626" }}>{err}</p>
        )}
    </div>
);

// ── Component ────────────────────────────────────────────────────────────────
const FormSaleGlass = (props) => {
    const { newSale, setNewSale } = props;

    // update state passed from prop
    // condition to update nested state
    const handleUpdate = (set, field, value) => {
        if (field === "cost") {
            set((state) => ({
                ...state,
                [field]: value,
            }));
        } else {
            set((state) => ({
                ...state,
                productSpecification: {
                    ...state.productSpecification,
                    doorLeft: {
                        ...state.productSpecification.door,
                        doorInsert: {
                            ...state.productSpecification.doorLeft.doorInsert,
                            [field]: value,
                        },
                    },
                },
            }));
        }
    };

    return (
        <div>
            {/* Insert Design — full width */}
            <F label="Insert Design">
                <input
                    style={inputBase}
                    {...focusHandlers}
                    type="text"
                    list="insertDesigns"
                    name="design"
                    value={newSale.productSpecification.doorLeft.doorInsert.design}
                    onChange={(e) => handleUpdate(setNewSale, "design", e.target.value)}
                    placeholder="Insert Design"
                />
                <datalist id="insertDesigns">
                    {InsertDesigns.map((insertDesign) => (
                        <option key={insertDesign.design} value={insertDesign.design} />
                    ))}
                </datalist>
            </F>

            {/* Size */}
            <span style={subHeader}>Size</span>
            <div style={g2}>
                <F label="Width">
                    <input
                        style={inputBase}
                        {...focusHandlers}
                        type="number"
                        name="width"
                        value={newSale.productSpecification.doorLeft.doorInsert.width}
                        onChange={(e) => handleUpdate(setNewSale, "width", e.target.value)}
                    />
                </F>
                <F label="Height">
                    <input
                        style={inputBase}
                        {...focusHandlers}
                        type="number"
                        name="height"
                        value={newSale.productSpecification.doorLeft.doorInsert.height}
                        onChange={(e) => handleUpdate(setNewSale, "height", e.target.value)}
                    />
                </F>
            </div>

            {/* Quantity & Cost */}
            <div style={g2}>
                <F label="Quantity">
                    <input
                        style={inputBase}
                        {...focusHandlers}
                        type="number"
                        name="quantity"
                        value={newSale.productSpecification.doorLeft.doorInsert.quantity}
                        onChange={(e) => handleUpdate(setNewSale, "quantity", e.target.value)}
                    />
                </F>
                <F label="Cost">
                    <input
                        style={inputBase}
                        {...focusHandlers}
                        type="number"
                        name="cost"
                        value={newSale.productSpecification.cost}
                        onChange={(e) => handleUpdate(setNewSale, "cost", e.target.value)}
                    />
                </F>
            </div>
        </div>
    );
};

export default FormSaleGlass;
